import React, { useState, useEffect }  from 'react';
import { useParams,useHistory } from "react-router-dom";
import CssBaseline from '@mui/material/CssBaseline';
import clsx from 'clsx';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Modal from '@mui/material/Modal';
import {clientService as service, paymenttypeService, routeService, activityService} from "../../services"
import Form from "../form/Form"
import toast from 'toasted-notes'
import 'toasted-notes/src/styles.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { PinDropSharp } from '@mui/icons-material/';
import {initElementStreet, estructureformStreet, getElementStreet} from '../utils/Data';
import { Box } from '@mui/system';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1200,
  maxWidth:"80%",
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


const initClient = {
    code:"",
    nif:"",
    comercialName:"",
    email:"",
    phone: "",
    street: initElementStreet,
    dtoBill: 0.0,
    recargoEqui:false,
    exentoIva:false,
    specialPrice:false,
    paymentType:{id:null, name: null},
    activity:{id:null, name: null},
    route:{id:null, name: null},
    nameContact: "",
    note: "",
 };


export default function ModalClient(props) {
 const [clientform,setClientform] = useState({...initClient});
 const [openClient, setOpenClient] = useState(false);
 const [editable,setEditable] = useState(props.editable != null?props.editable:true)
 
 
 const estructureformClient =  [
  {
    type:"input",
    name: "code",
    col: 4,
    readonly:true
   },
   {
     type:"input",
     name: "nif",
     col: 4
   },
   {
     type:"input",
     name: "comercialName",
     col: 4
   },
   {
    type:"input",
    name: "nameContact",
    col: 4
   },
   {
      type:"input",
      name: "phone",
      col: 4
   },
   {
      type:"input",
      name: "dtoBill",
      col: 4,
      inputtype:"number"
   },
   {
      type:"autocomplete",
      name: "route.id",
      service:routeService.combo,
      col: 4
    },
    {
      type:"autocomplete",
      name: "paymentType.id",
      service:paymenttypeService.combo,
      col: 4
    },
    {
      type:"autocomplete",
      name: "activity.id",
      service:activityService.combo,
      col: 4
    },
    {
       type:"checkbox",
       name: "recargoEqui",
       col: 4
    },
    {
       type:"checkbox",
       name: "exentoIva",
       col: 4
    },
    {
       type:"checkbox",
       name: "specialPrice",
       col: 4
    },
    ...estructureformStreet

  ];

const handleCloseClient = () => {
    setOpenClient(false);
    setClientform({...initClient});
  }

const saveFormClient = (object) => {
    handleCloseClient();
    service.create(object, (data, error) => {
    if(data){
        props.saveClient(data.data);
    }
});

}


return (
    <Grid item sm={12} xs={12} style={{textAlign:'right'}}>
        {editable && <Button variant="contained" color="secondary" style={{marginLeft:'10px'}} onClick={() => setOpenClient(true)}> Nuevo cliente </Button>}

      <Modal
          open={openClient}
          onClose={handleCloseClient}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description">
          <Box sx={style}>
            <div>
              <h2>Nuevo cliente</h2>
            </div>
            <div>
                <Form t={props.t} i18n={'client'}  objectform={clientform} fields={estructureformClient}  searchFilter={saveFormClient} cleanFilter={handleCloseClient} labelsave={props.t('general.save')} labelcancel={props.t('general.cancel')}  />
            </div>
        </Box>
        </Modal>
    </Grid>
  );
}

